/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portal_Step_Train_BodyInputs */

const en_portal_step_train_body = /** @type {(inputs: Portal_Step_Train_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your training plan, your meals and your progress are here once you sign in.`)
};

const pl_portal_step_train_body = /** @type {(inputs: Portal_Step_Train_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plan treningowy, jadłospis i postępy czekają w aplikacji po zalogowaniu.`)
};

/**
* | output |
* | --- |
* | "Your training plan, your meals and your progress are here once you sign in." |
*
* @param {Portal_Step_Train_BodyInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const portal_step_train_body = /** @type {((inputs?: Portal_Step_Train_BodyInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portal_Step_Train_BodyInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_portal_step_train_body(inputs)
	return en_portal_step_train_body(inputs)
});